import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 6.5rem;
  transition: ease opacity .3s, ease height .3s, ease min-height .3s, ease max-height;
  position: relative;
  &.mobile-search {
    min-height: 170px;
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 6.25rem;
  justify-content: space-between;
  align-items: center;
  padding: 0 2.5rem;
  z-index: 1;
  background-color: #FFFFFF;
  box-shadow: 0px 0.25rem 1rem rgba(0, 0, 0, 0.04);
`;

export const TopLeftContainer = styled.div`
  display: flex;
  gap: 2rem;
`;

export const Logo = styled.img`
  width: 3.5rem;
`;

export const TopLeftContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const TopLeftContent = styled.h2`
  font-weight: 400;
  font-size: 1.75rem;
  line-height: 1.75rem;
  color: #272848;
`;

export const TopLeftContentStrong = styled.strong`
  font-size: 1.75rem;
  line-height: 1.75rem;
  color: #272848;
  white-space: nowrap;
`;

export const TopRightSearchContainer = styled.div`
  width: 28.125rem;
  height: 3.75rem;
  background-color: #2460D708;
  border-radius: 100px;
  display: flex;
  align-items: center;
  padding: 0 1rem 0 1.75rem;
  gap: 1.3125rem;
  @media (max-width: 840px) {
    display: none;
    &.mobile {
      height: 60px;
      display: flex;
      width: 78%;
    }
  }
`;

export const TopRightSearchIcon = styled.img`

`;

export const TopRightInput = styled.input`
  width: 100%;
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 1.5rem;
  outline: none;
  border: none;
  background-color: transparent;
  &::placeholder {
    color: #8B8B8B;
    opacity: 1;
  }
`;

export const TopRightMenuIconsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  gap: 26px;
  background-color: #FFFFFF;
  @media (min-width: 840px) {
    display: none;
  }
`;

export const TopRightMenuIconContainer = styled.div`

`;

export const TopRightMenuIcon = styled.img`
  cursor: pointer;
  width: 2rem;
  &.search {
    width: 18px;
    filter: invert(13%) sepia(23%) saturate(1413%) hue-rotate(199deg) brightness(30%) contrast(91%);
  }
  &.dark-home {
    filter: invert(16%) sepia(17%) saturate(1389%) hue-rotate(199deg) brightness(30%) contrast(98%);
  }
`;

export const TopRightHomeContainer = styled.a`
  width: 14.5625rem;
  display: flex;
  height: 3.5625rem;
  background: #2460D7;
  border-radius: 100px;
  align-items: center;
  gap: 1rem;
  padding: 0 2rem;
  cursor: pointer;
  transition: ease background-color .3s;
  text-decoration: none;
  &:hover {
    background-color: #0044CC;
  }
  @media (max-width: 840px) {
    display: none;
  }
`;

export const TopRightHomeIcon = styled.img`
  width: 1.5rem;
`;

export const TopRightHomeContent = styled.span`
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 1.5rem;
  color: #FFFFFF;
  white-space: nowrap;
`;